// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"245":"9500c835","247":"7f9d64db","513":"aec8e3dc","665":"68e4b565","706":"cc727622"}[chunkId] + ".chunk.js";
};